export default {
      id: "ic_apps-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.svg#ic_apps",
      toString: function () {
        return this.url;
      }
    }